export const MyColor = {
    primary: '#8FC256',
    sub: '#BE9E73',
    blue: '#000684',
    red: '#E71F76',
    bg: '#F9F8F0',
}



